import { render, staticRenderFns } from "./orders-container.vue?vue&type=template&id=79002548&scoped=true&lang=pug"
import script from "./orders-container.js?vue&type=script&lang=js&external"
export * from "./orders-container.js?vue&type=script&lang=js&external"
import style0 from "./orders-container.vue?vue&type=style&index=0&id=79002548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79002548",
  null
  
)

export default component.exports